




















































import Vue from "vue";
import Mfa from "./Mfa.vue";
import OtpFormInput from "./OtpFormInput.vue";
import userInfoProvider from '@/services/userInfoProvider';
import loginService from "@/services/identity-authen/loginService"

export default Vue.extend({
  name: "SmsOtpLogin",
  components: { Mfa, OtpFormInput },
  data() {
    const self: any = this;
    const prepareRes = loginService.getPrepareLoginResponse();
    return {
      self,
      prepareRes,
      isShowQaCode: true,
      loginMethodOptions: [],
      buttonResetOTP: {
        resetOTP: {
          attrs: {
            xClass: "btn-reset no-border my-4",
            height: 40,
          },
          content: {
            text: "Reset TOTP",
            icon: "icon-reset-otp",
            iconAttrs: {
              class: "mr-1 mt-1 red-color",
            },
          },
          on: {
            xClick({ self }) {
              const prepareRes = loginService.getPrepareLoginResponse();
              if (
                  typeof prepareRes === 'object' &&
                  Array.isArray(prepareRes.available_mfas) &&
                  prepareRes.available_mfas.length
              ) {
                if (prepareRes.available_mfas.includes('SmsOtp') && prepareRes.available_mfas.includes('Totp')) {
                  self.$router.push({ name: 'reset-totp-enter-phone'});
                } else {
                  self.$router.push({ name: 'reset-totp-no-phone'});
                }
              }
            },
          },
        },
      }
    };
  },
  methods: {
    parseData(dataStr) {
      return JSON.parse(dataStr);
    }
  },
  async created() {}
});
